export function isProduction() {
  const environment = process.env.REACT_APP_ENV
  const nodeEnv = process.env.NODE_ENV

  return nodeEnv === 'production' && environment === 'production'
}

export function isHomolog() {
  const environment = process.env.REACT_APP_ENV

  return environment === 'homolog'
}
